import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Component({
    selector: 'std-click-outside',
    template: `<ng-content></ng-content>`,
    styles: [],
    standalone: false
})
export class ClickOutsideComponent {
  constructor(private elementRef: ElementRef) {}

  @Output() clickOutside: EventEmitter<void> = new EventEmitter();
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: PointerEvent) {
    const nativeElement: any = this.elementRef.nativeElement;
    const clickedInside: boolean = nativeElement.contains(event.target);
    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
